export default {
  common: {
    Caption: "Thông tin đơn vị",
    GoToUserList: "Đi tới danh sách người dùng"
  },
  Detail: {
    BudgetCode: "Mã QHNS",
    OrganizationName: "Tên đơn vị",
    OrganizationUnitName: "Tên phòng ban",
    OrganizationCode: "Mã đơn vị",
    ParentOrganization: "Thuộc đơn vị",
    TaxCode: "Mã số thuế",
    AdministrativeLevel: "Cấp hành chính",
    CareerField: "Lĩnh vực sự nghiệp",
    Province: "Tỉnh/Thành phố",
    District: "Quận/Huyện",
    Ward: "Xã/Phường",
    Address: "Địa chỉ",
    Email: "Email",
    PhoneNumber: "Số điện thoại",
    Fax: "Fax",
    Website: "Website",
    AddTitle: "Thêm phòng ban",
    EditTitle: "Sửa phòng ban",
    SortTitle: "Sắp xếp phòng ban",
    ActiveTitle: "Trạng thái",
    InActiveTile: "Ngừng hoạt động phòng ban",
    Active: {
      All: "Tất cả trạng thái",
      True: "Đang hoạt động",
      False: "Ngừng hoạt động"
    },
    Option: {
      Deparment: "Phòng ban thuộc đơn vị:",
      AddDeparment: "Thêm phòng ban"
    },
    Input: {
      Deparment: "Phòng ban thuộc đơn vị",
      OrganizationUnitName: "Nhập tên phòng ban",
    }
  },
  Message: {
    "ConfirmDelete": "Khi xóa {0} <b>{1}</b>, phần mềm sẽ xóa các đơn vị con và phòng ban tương ứng. Bạn có chắc muốn xóa không?",
    ConfirmDeleteMutiTitle: "Khi xóa các {0} phần mềm sẽ xóa các đơn vị con và phòng ban tương ứng. Bạn có chắc muốn xóa không?",
    AddSuccess: 'Thêm phòng ban thành công',
    EditSuccess: 'Sửa phòng ban thành công',
  },
  SettingOrder: {
    OrganizationName: "Nhập tên đơn vị...",
    SubTitle: "Chọn, giữ và kéo thả phòng ban vào vị trí mà bạn muốn sắp xếp."
  }
  ,
  Input: {
    OrganizationName: "Nhập tên đơn vị",
    ChooseOrganizationName: "Chọn đơn vị"
  },
}